<template>

    <div class="layout__padding-clear layout__width-70 text__align-center">
        <div class="layout__margin-60-0 layout__overflow-hidden">

            <img class="layout__padding-20-0 layout__width-200px"
                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/sensier/sensier-icon.png">

            <p class="text__colour-white layout__padding-20-0">Land & New Homes</p>

            <div class="text__size-36 text__colour-white">Christie’s World | Sensier</div>

            <hr>

            <p class="text__line-height-30px text__colour-white">
                Our role was to highlight the striking design of the Sensier building to attract the young professional
                to this premium development. The branding, design and imagery all reflected the unique gull-wing
                architectural features of the site and the viewpoints and furnishings of the CGI were geared towards the
                young professional target market.
            </p>

            <hr>

            <el-button class="button-red layout__width-200px"
                       v-on:click="showcase()">Back to our work
            </el-button>


            <div class="layout__overflow-hidden layout__margin-40-0">
                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/sensier/Sensier-case-study-.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/sensier/Sensier-case-study-2.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/sensier/Sensier-case-study-3.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/sensier/Sensier-case-study-7.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/sensier/Sensier-case-study-5.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/sensier/Sensier-case-study-4.jpg">
            </div>


        </div>
    </div>

</template>

<script>
    import Router from '../../../router';
    import {Carousel, Slide} from 'vue-carousel';

    export default {
        name: "landnewhomes",
        props: {},
        components: {
            Carousel,
            Slide
        },
        mixins: [],
        data() {
            return {}
        },
        created() {
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            },
            print() {
                Router.push({
                    name: '/products/print'
                });
            },
            digital() {
                Router.push({
                    name: '/products/print'
                });
            },
            showcase(page) {
                Router.push({
                    name: '/services/design-studio/our-work',
                    query: {
                        client: page,
                    }
                });
            }
        },
    };
</script>